import React, {Suspense, lazy} from 'react';
import * as Sentry from '@sentry/react';

import {isSuppressedPath} from '../utils/floatingWidgets';
import {useGuides} from './GuidesContext';
import {GuideReturnBar} from './GuideReturnBar';
import {MODE_PREVIEW} from './constants';
import './Guides.scss';

// Joyride (y la tarjeta) se bajan recién cuando hay una guía activa.
const GuideRunner = lazy(() => import('./GuideRunner'));

/**
 * Punto de montaje de las guías en `App.js`. Decide si se dibuja algo; QUÉ se dibuja lo decide el
 * provider. En una ruta sin marco (login, portal, reportes públicos) no se dibuja nada, salvo la
 * vista previa que el superadmin pidió a propósito. Sin guía activa, puede quedar ofrecido volver a
 * «Aprende Dashbo» (una guía que vino de ahí terminó o se cerró): eso es liviano y no baja joyride.
 */
function GuidesEntry() {
    const {active, returnOffer} = useGuides();
    if (!active) {
        return returnOffer && !isSuppressedPath(window.location.pathname) ? <GuideReturnBar/> : null;
    }
    if (active.mode !== MODE_PREVIEW && isSuppressedPath(window.location.pathname)) return null;
    return (
        <Suspense fallback={null}>
            <GuideRunner/>
        </Suspense>
    );
}

/**
 * Mismo criterio que el widget de feedback: el `ErrorBoundary` global pinta una pantalla completa de
 * «Algo salió mal», y un bug de una guía no puede tumbar la app. Con `fallback={null}` la guía
 * desaparece en silencio y el error llega a Sentry.
 */
export default function GuidesEntryBoundary() {
    return (
        <Sentry.ErrorBoundary fallback={null}>
            <GuidesEntry/>
        </Sentry.ErrorBoundary>
    );
}
